import { SocialView } from "./SocialView";

export const SocialRead = () => {
    return <SocialView />;
};
